
// function getQueryParams() {
//     const result = {}
//     const queryString = window.location.search;
//     const reg = /[?&][^?&]+=[^?&]/g
//     const found = queryString.match(reg)
//     if (found) {
//         found.forEach(item => {
//             let temp = item.substring(1).split('=')
//             let key = temp[0];
//             let value = temp[1];
//             result[key] = value
//         })
//     }
//     return result
// }
import axios from 'axios'
// create an axios instance
const service = axios.create({
  // baseURL: 'https://api-jh-sandbox.yijianai.com', // url = base url + request url
  // baseURL: 'https://api-jh.yijianai.com', // url = base url + request url
  baseURL: 'https://api-jh2.yijianai.com', // url = base url + request url
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (res.code !== 200) {
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js